import products from "../data/products";
import ProductCard from "./ProductCard";
import './Catalogue.css'
function Catalogue() {
  return (
   <section id="catalogue" className="catalogue">
  <h2>Product Catalogue</h2>

  <div className="grid">
    {products.map(product => (
      <ProductCard key={product.id} product={product} />
    ))}
  </div>
</section>

  );
}

export default Catalogue;
